import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/styles";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import login_navender_logo from "../images/navender_logo.png";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
const apiUrl = RUN_TIME_API_ENDPOINT;
const Trial = (props) => {
  console.log("======", props.location.search.split("=")[1]);
  const [newPass, setNewPass] = useState("");
  const [rePass, setRePass] = useState("");
  const [passError, setPassError] = useState(false);
  const [newPassError, setNewPassError] = useState(false);
  const [apiErr, setApiErr] = useState("");
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const regex =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  const onNewPassChange = (e) => {
    regex.test(e.target.value) ? setNewPassError(false) : setNewPassError(true);
    setNewPass(e.target.value);
  };

  const onRePassChange = (e) => {
    newPass !== e.target.value ? setPassError(true) : setPassError(false);
    setRePass(e.target.value);
  };

  useEffect(() => {
    setLoader(true);
    const url = `${apiUrl}/valid-token?token=${
      props.location.search.split("=")[1]
    }`;
    const options = CommonHeaderOption();
    options.method = "GET";
    options.headers = {
      // 'authorization': tokenId,
      "Content-Type": "application/json",
    };
    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Token Valid") {
          setLoader(false);
          console.log("result", data.message);
        } else {
          setLoader(false);
          Swal.fire({
            text: "This link has expired",
            confirmButtonText: `OK`,
            icon: "error",
          }).then((data) =>
            props.history.push({
              pathname: "/login",
            })
          );
        }
      })
      .catch((error) => {
        setLoader(false);
        Swal.fire({
          text: "link not found",
          confirmButtonText: `OK`,
          icon: "error",
        })
        console.error("Error:", error);
      });
  }, []);

  const onSubmit = () => {
    setButtonLoader(true);
    // e.preventDefault();
    console.log("new " + newPass + "   re   " + rePass);
    const url = `${apiUrl}/reset-password?token=${
      props.location.search.split("=")[1]
    }`;
    const options = CommonHeaderOption();
    options.method = "POST";
    options.headers = {
      // 'authorization': tokenId,
      "Content-Type": "application/json",
    };
    options.body = JSON.stringify({
      password: newPass,
      password_confirmation: rePass,
    });
    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        setButtonLoader(false);
        if (data.message === "Password reset Successfully") {
          Swal.fire({
            text: "Password Reset Successfully",
            confirmButtonText: `OK`,
            icon: "success",
          }).then((data) =>
            props.history.push({
              pathname: "/login",
            })
          );
          console.log("Success:", data);
        } else {
          setApiErr(data.error);
          console.log("Success:", data.error);
        }
      })
      .catch((error) => {
        setButtonLoader(false);
        Swal.fire({
          text: "Failed to reset password",
          confirmButtonText: `OK`,
          icon: "error",
        })
        console.error("Error:", error);
      });
  };
  // console.log('Trial hit', props);
  return (
    <React.Fragment>
      {loader ? (
        <div className="email-login-page"><div className="login-loader" /></div>
      ) : (
        <ThemeProvider theme={props.theme}>
          <div className="email-login-page">
            <div>
              <img src={login_navender_logo} />
            </div>
            <div className="email-login-form">
              {/* <form onSubmit={onSubmit}> */}
              <div>
                <label for="fname">
                  New Password<sup className="asterisk">*</sup>
                </label>
                <input
                  id="inputPassword"
                  name="password"
                  type="password"
                  value={newPass}
                  onChange={onNewPassChange}
                />
                {newPassError && (
                  <div className="email-login-error">{"Invalid Password"}</div>
                )}
              </div>
              <div>
                <label for="fname">
                  Re-Enter Password<sup className="asterisk">*</sup>
                </label>
                <input
                  id="reEnterPassword"
                  name="password"
                  type="password"
                  value={rePass}
                  onChange={onRePassChange}
                />
                {passError && (
                  <div className="email-login-error">
                    {"Password do not match"}
                  </div>
                )}
              </div>
              {apiErr !== "" && (
                <div className="email-login-error">{apiErr}</div>
              )}
              <div>
                <button
                  disabled={
                    passError || rePass === "" || newPass === "" || newPassError || buttonLoader
                  }
                  className="email-login-button"
                  type="submit"
                  onClick={onSubmit}
                >
                  Reset Password
                </button>
                {buttonLoader && (
                    <div className="login-loader" />)}
              </div>
              <div className="reset-instruction">
                <p>Reset Password Instructions: </p>
                <ul>
                <li>Minimum 8 characters</li>
                <li>At least one uppercase letter</li>
                <li>At least one number</li>
                <li>At least one special character</li>
                </ul>
              </div>
            </div>
          </div>
        </ThemeProvider>
      )}
    </React.Fragment>
  );
};

export default Trial;
